var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-category-tree-form" },
    [
      _vm.form.nodeId
        ? _c(
            "div",
            { staticClass: "yxtbiz-category-tree-form-span bg-gray-2" },
            [
              _c(
                "yxt-row",
                [
                  _c(
                    "yxt-col",
                    {
                      staticClass: "yxtbiz-category-tree-form-span-label",
                      attrs: { span: 3 },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("pc_biz_lbl_creator".d("创建人"))) +
                          "\n      "
                      ),
                    ]
                  ),
                  _c("yxt-col", { attrs: { span: 21 } }, [
                    _c("div", [_vm._v(_vm._s(_vm.form.createdBy))]),
                  ]),
                ],
                1
              ),
              _c(
                "yxt-row",
                [
                  _c(
                    "yxt-col",
                    {
                      staticClass: "yxtbiz-category-tree-form-span-label",
                      attrs: { span: 3 },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("pc_biz_lbl_createtime").d("创建时间")
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                  _c("yxt-col", { attrs: { span: 21 } }, [
                    _c("div", [_vm._v(_vm._s(_vm.form.createdAt))]),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.show
        ? _c(
            "yxt-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rule,
                "label-position": "top",
                "label-width": "100px",
              },
            },
            [
              _vm.form.nodeId !== "1"
                ? _c(
                    "yxt-form-item",
                    {
                      attrs: {
                        label: _vm.$t("pc_biz_cate_parent").d("所属分类"),
                        prop: "pnodeId",
                      },
                    },
                    [
                      _c("yxtbiz-category-selector", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          code: _vm.code,
                          apiName: _vm.apiName,
                          navCode: _vm.navCode,
                          dataPermissionCode: _vm.dataPermissionCode,
                        },
                        on: { change: _vm.change },
                        model: {
                          value: _vm.pnode,
                          callback: function ($$v) {
                            _vm.pnode = $$v
                          },
                          expression: "pnode",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "yxt-form-item",
                {
                  attrs: {
                    label: _vm.$t("pc_biz_cate_name").d("分类名称"),
                    prop: "name",
                  },
                },
                [
                  _c("yxt-input", {
                    attrs: {
                      maxlength: 100,
                      "show-word-limit": "",
                      placeholder: _vm
                        .$t("pc_biz_core_tip_placeholder")
                        .d("请输入"),
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _vm.showDes
                ? _c(
                    "yxt-form-item",
                    {
                      attrs: { label: _vm.$t("pc_biz_cate_des").d("分类描述") },
                    },
                    [
                      _c("yxt-input", {
                        attrs: {
                          placeholder: _vm
                            .$t("pc_biz_core_tip_placeholder")
                            .d("请输入"),
                          type: "textarea",
                          maxlength: 200,
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.form.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "description", $$v)
                          },
                          expression: "form.description",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }